export default function sliderFunction() {
    if ($('.v-accueil__fonctionnalites--items').length > 0) {

        const $slider = {
            name: $('.v-accueil__fonctionnalites--items'),
            arrows: {
                next: $('.v-accueil__fonctionnalites--btns .next'),
                prev: $('.v-accueil__fonctionnalites--btns .prev')
            },
        }

        $slider.name.slick({
            infinite: false,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoplay: false,
            draggable: true,
            adaptiveHeight: false,
            fade: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
        });

        $slider.arrows.next.click(function () {
            $slider.name.slick('slickNext');
            toggleArrowsVisibility($slider);
        });
        $slider.arrows.prev.click(function () {
            $slider.name.slick('slickPrev');
            toggleArrowsVisibility($slider);
        })
    }

    function toggleArrowsVisibility(obj) {
        const $slider = obj;
        if ($slider.name.slick('slickCurrentSlide') === 0) {
            $slider.arrows.prev.addClass('hidden-arrow');
        } else {
            $slider.arrows.prev.removeClass('hidden-arrow');
        }

        if ($slider.name.slick('slickCurrentSlide') === $slider.name.slick('getSlick').slideCount - 1) {
            $slider.arrows.next.addClass('hidden-arrow');
        } else {
            $slider.arrows.next.removeClass('hidden-arrow');
        }
    }
}
